<script>
    import { auth, db } from './firebase';
    import FamilyForm from './FamilyForm.svelte';

    let family = null;
    function activate() {
        family = {
            name: 'Nová rodina',
            firstMonth: null,
            maxPeople: '',
            monthlyPayment: '',
            people: []
        };
    }
    function cancel() {
        family = null;
    }
    function submit() {
        db
            .collection('families')
            .add({
                ...family,
                owner: auth.currentUser.uid
            });
        family = null;
    }
</script>

{#if family}
    <FamilyForm family={family} on:cancel={cancel} on:submit={submit} />
{:else}
    <button type="button" on:click={activate}>Nová rodina</button>
{/if}